export default {
    "stats.title": "Mes Statistiques",
    "stats.nav.dashboard": "Tableau de bord",
    "stats.last_update": "Mis à jour en temps réel",
    "stats.global.quiz": "Complétion Quiz",
    "stats.global.accuracy": "Précision Globale",
    "stats.global.review": "Questions à revoir",
    "stats.global.streak": "Série",
    "stats.global.streak_unit": "j",

    "stats.badges.title": "Badges & Succès",
    "stats.badges.count": "{{count}} Badge",
    "stats.badges.count_plural": "{{count}} Badges",
    "stats.badges.congrats": "Félicitations pour ce succès !",
    "stats.badges.empty_title": "Aucun succès pour le moment",
    "stats.badges.empty_desc": "Continuez à apprendre pour débloquer des badges exclusifs.",

    "stats.charts.progress_title": "Progression par Thème",
    "stats.charts.accuracy_title": "Taux de Réussite",
    "stats.charts.legend_progress": "Progression",
    "stats.charts.legend_accuracy": "Précision",

    "stats.table.title": "Détails par catégorie",
    "stats.table.col_quiz": "Thème",
    "stats.table.col_flashcards": "Flashcards",
    "stats.table.col_accuracy": "Précision",
    "stats.table.col_challenges": "Défis",
    "stats.table.col_action": "Action",
    "stats.table.quiz_count": "{{completed}} / {{total}} quiz",
    "stats.table.flashcards_desc": "Cartes mémorisées",
    "stats.table.errors_count": "{{count}} erreur(s)",
    "stats.table.perfect": "100% Maîtrisé",
    "stats.table.review_btn": "Réviser"
};
